import { render, staticRenderFns } from "./QCheckBoxes.vue?vue&type=template&id=3f074a21&"
import script from "./QCheckBoxes.vue?vue&type=script&lang=js&"
export * from "./QCheckBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports